<style>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.management-list {
  display: flex;
  align-items: center;
  /* margin-bottom: 15px; */
}

.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
}

.management-name {
  flex-shrink: 0;
}

.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  border: 1px solid grey;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
}

.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}

.input-item .input-title {
  margin-right: 14px;
}

.add {
  text-align: left;
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}

.del {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 10px;
}

.product-item {
  display: flex;
  margin-top: 10px;
}

.product {
  display: flex;
  align-items: center;
}

.product-img {
  width: 60px;
  height: 60px;
  margin-right: 15px;
}

.product-text {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.depart-choose {
  width: 300px;
  height: 34px;
  border: 1px solid #dcdfe6;
  box-sizing: content-box;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.depart-choose span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.place-choose {
  padding-left: 10px;
  color: #dcdfe6;
}

.place-show {
  padding-left: 10px;
}

.task-precent {
  width: 70px;
  height: 20px;
  margin: 0 10px;
}
</style>
<template>
  <div class="task-content " v-loading.fullscreen.lock="fullscreenLoading">
    <div class="header">
      <div class="back" @click="$router.go(-1)">返回</div>
      <div class="task-title">
        {{templateName }}
      </div>
    </div>
    <div class="title">基本信息配置</div>
    <div class="base-content">
      <div class="base-info">
        <div class="base-title"><span style="color: red">*</span>委托方：</div>
        <div style="width: 300px;text-align:left;">{{tenantName}}</div>
      </div>
      <div class="base-info">
        <div class="base-title"><span style="color: red">*</span>服务商：</div>
        <div>{{serviceTenantName}}</div>
        <!-- <el-input v-model="templateName" style="width: 300px" placeholder="示例：XX公司任务模版"></el-input> -->
      </div>
    </div>
    <div class="base-content">
      <div class="base-info">
        <div class="base-title"><span style="color: red">*</span>执行部门：</div>
        <div>{{this.getDeliverName(departmentList)}}</div>
        <!-- <el-input v-model="templateName" style="width: 300px" placeholder="示例：XX公司任务模版"></el-input> -->
      </div>
    </div>
    <div class="title">系统功能配置</div>
    <!-- 配置 -->
    <div class="back-color-fff p16">
      <el-table :data="tableData" :height="tableHeight" stripe border header-cell-class-name="table_header"
        style="width: 100%">
        <el-table-column label="序号" fixed="left" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <!-- 任务大类 -->
        <el-table-column prop="taskType" fixed="left" label="任务大类" show-overflow-tooltip width="150"
          header-align="center" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.taskType }}</span>
          </template>
        </el-table-column>
        <!-- 平台任务名称 -->
        <el-table-column fixed="left" prop="parentTemplateDetailName" label="平台任务名称" show-overflow-tooltip width="150"
          header-align="center" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.parentTemplateDetailName || '-' }}</span>
          </template>
        </el-table-column>
        <!-- 任务名称 -->
        <el-table-column prop="taskContentName" label="项目任务名称" show-overflow-tooltip width="150" header-align="center"
          align="center">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.taskContentName" placeholder="请填写" />
          </template>
        </el-table-column>
        <!-- 系统功能 -->
        <el-table-column prop="menuName" label="系统功能" show-overflow-tooltip header-align="center" width="180"
          align="center">
          <template slot-scope="scope">{{ scope.row.menuName || '-' }}{{ scope.row.menuRemark ? '（' +
            scope.row.menuRemark
            + '）' : ''
            }}</template>
        </el-table-column>

        <!-- 药企报价 -->
        <el-table-column prop="taskPrice" label="药企报价" header-align="center"
          :width="taskPriceModel == 2 ? '300' : '200'" align="center">
          <!-- <template slot-scope="scope">
            <div style="display: flex">
              <el-input  size="mini" type="input" style="width: 60px; float: left" :maxlength="30" placeholder="请输入价格"
                v-model="scope.row.tenantTaskPrice" oninput="value=value.replace(/[^\.\d]/g,'')">
              </el-input>
              <el-select  size="mini"   style="width: 120px; float: left; margin-left: 10px" v-model="scope.row.tenantTaskPriceUnitGuid"
                placeholder="单位" @change="handleSelecTaskPriceUnit(scope.row.tenantTaskPriceUnitGuid, 0, scope.$index)">
                <el-option v-for="(item, index) in taskPriceUnitList" :key="index"
                  :label="item.paramValue" :value="item.guid"></el-option>
              </el-select>
            </div>
          </template> -->
          <template slot-scope="scope">
            <!-- 区间价 -->
            <div v-if="taskPriceModel == 2">
              <div style="display: flex">
                <el-input type="input" size="mini" style="width: 128px; margin-right: 5px;" :maxlength="30"
                  placeholder="请输入" v-model.trim="scope.row.tenantMinPrice"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                </el-input>
                至
                <el-input type="input" size="mini" style="width: 128px; margin:0 5px;" :maxlength="30" placeholder="请输入"
                  v-model.trim="scope.row.tenantMaxPrice"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                </el-input>
                <el-select size="mini" v-model="scope.row.tenantTaskPriceUnitGuid" placeholder="单位"
                  @change="handleSelecTaskPriceUnit(scope.row.tenantTaskPriceUnitGuid, 0, scope.$index)">
                  <el-option v-for="(item, index) in taskPriceUnitList" :key="index" :label="item.paramValue"
                    :value="item.guid"></el-option>
                </el-select>
              </div>
            </div>
            <!-- 固定价 -->
            <div v-else>
              <div style="display: flex">
                <el-input type="input" size="mini" style="width: 128px; margin-right: 5px;" :maxlength="30"
                  placeholder="请输入价格" v-model.trim="scope.row.tenantTaskPrice"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                </el-input>
                <el-select size="mini" v-model="scope.row.tenantTaskPriceUnitGuid" placeholder="单位"
                  @change="handleSelecTaskPriceUnit(scope.row.tenantTaskPriceUnitGuid, 0, scope.$index)">
                  <el-option v-for="(item, index) in taskPriceUnitList" :key="index" :label="item.paramValue"
                    :value="item.guid"></el-option>
                </el-select>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 业务员报价 -->
        <el-table-column prop="taskPrice" label="业务员报价" header-align="center" width="180" align="center">
          <template slot-scope="scope">
            <div style="display: flex">
              <el-input size="mini" type="input" style="width: 60px; float: left" :maxlength="30" placeholder="请输入价格"
                v-model="scope.row.taskPrice"
                oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
              </el-input>
              <div style="word-break: keep-all;margin-left:10px">{{ scope.row.taskPriceUnit }}</div>
              <!-- <el-select  size="mini" style="width: 120px; float: left; margin-left: 10px" v-model="scope.row.taskPriceUnitGuid"
                placeholder="单位" @change="handleSelecTaskPriceUnit(scope.row.taskPriceUnitGuid, 1, scope.$index)">
                <el-option v-for="(item, index) in taskPriceUnitList" :key="index"
                  :label="item.paramValue + '(' + item.paramValue1 + ')'" :value="item.guid"></el-option>
              </el-select> -->
            </div>
          </template>
        </el-table-column>
        <!-- 折扣比列 -->
        <!-- <el-table-column v-if="taskPriceModel==2" prop="discountRatio" label="折扣比例" header-align="center" width="120"
          align="center">
          <template slot-scope="scope">
            <el-input size="mini"
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^\./g, '')"
              placeholder="请输入" v-model.trim="scope.row.discountRatio"></el-input>
          </template>
        </el-table-column> -->

        <!-- 计算方式 -->
        <el-table-column prop="calcType" label="计算方式" show-overflow-tooltip width="120" header-align="center"
          align="center">
          <template slot-scope="scope">
            <el-select size="mini" v-model="scope.row.calcType" placeholder="计算方式">
              <el-option v-for="(item, index) in calcTypeList" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- 任务量设置 -->
        <el-table-column prop="taskTotal" label="任务量单位" header-align="center" width="120" align="center">
          <template slot-scope="scope">
            <div style="display: flex;justify-content:center;">
              <el-select size="mini" style="width: 120px; float: left" v-model="scope.row.taskTotalUnitGuid"
                @change="handleSelecTaskTotalUnit(scope.row.taskTotalUnitGuid,scope.$index)" placeholder="单位">
                <el-option v-for="(item, index) in taskTotalUnitList" :key="index"
                  :label="item.paramValue + '(' + item.paramValue1 + ')'" :value="item.guid"></el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="超量上限拦截" header-align="center" width="180" align="center">
          <span slot-scope="scope">
            <div style="display: flex;align-items:center;">
              <el-switch size="mini" v-model="scope.row.isOpenMaxTask" active-color="#4fa1a4" inactive-color="#DCDFE6"
                active-value="Y" inactive-value="N">
              </el-switch>
              <el-input size="mini" type="input" style="width: 80px;margin:0 10px" placeholder="请填写"
                v-model="scope.row.maxTaskValue" oninput="value=value.replace(/[^\.\d]/g,'')">
              </el-input>
              <span>%</span>
            </div>
          </span>
        </el-table-column>

        <!-- 品种信息 -->
        <!-- <el-table-column prop="taskType" label="定义品种" show-overflow-tooltip width="200" header-align="center"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.multipleSelection.length == 0" class="txt-color"
              @click="handleChooseGoods(scope.$index)">请选择</span>
            <span style="cursor: pointer" @click="handleChooseGoods(scope.$index)">{{
            getGoodsName(scope.row.multipleSelection)
            }}</span>
          </template>
        </el-table-column> -->

                <!-- 选择标签 -->
        <el-table-column prop="surveyLabelList" label="选择标签" show-overflow-tooltip width="250" header-align="center"
          align="center">
          <template slot-scope="scope">
            <el-cascader
              style="width: 100%;"
              :value="scope.row.surveyLabelList"
              :options="surveyLabelOptions"
              collapse-tags
              filterable
              :show-all-levels="false"
              :props="{
                value: 'value',
                label: 'text',
                children: 'childDictList',
                multiple: true,
                checkStrictly: true,
                emitPath: false,
              }"
              @change="(val) => updateLabels(val, scope.row)"
              clearable
              popper-class="cascader-popper"
            >
            </el-cascader>
          </template>
        </el-table-column>

        <!-- 打卡要求 -->
        <el-table-column prop="isAskClock" label="打卡要求" width="80" header-align="center" align="center">
          <template slot-scope="scope">
            <el-select size="mini" v-model="scope.row.isAskClock" placeholder="是否要求">
              <el-option v-for="(item, index) in ['是', '否']" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </template>
        </el-table-column>

        <!-- 拍照要求 -->
        <el-table-column label="拍照要求" header-align="center" width="200" align="center">
          <template slot-scope="scope">
            <div style="display: flex">
              <el-select size="mini" style="width: 80px; float: left; margin-right: 10px" v-model="scope.row.isAskPhoto"
                placeholder="是否要求">
                <el-option v-for="(item, index) in ['是', '否']" :key="index" :label="item" :value="item"></el-option>
              </el-select>
              <el-input size="mini" type="input" style="width: 100px; float: left" :maxlength="30" placeholder="至少几张"
                v-model="scope.row.minAskPhoto" oninput="value=value.replace(/[^\.\d]/g,'')">
              </el-input>
            </div>
          </template>
        </el-table-column>

        <!-- 上传资料 -->
        <el-table-column label="上传资料" header-align="center" width="200" align="center">
          <template slot-scope="scope">
            <div style="display: flex">
              <el-select size="mini" style="width: 80px; float: left; margin-right: 10px"
                v-model="scope.row.isAskUpload" placeholder="是否要求">
                <el-option v-for="(item, index) in ['是', '否']" :key="index" :label="item" :value="item"></el-option>
              </el-select>
              <el-input size="mini" type="input" style="width: 100px; float: left" :maxlength="30" placeholder="至少几张"
                v-model="scope.row.minAskUpload" oninput="value=value.replace(/[^\.\d]/g,'')">
              </el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="250px" label="操作" header-align="center" align="center" fixed="right"
          v-if="$route.query.isUse != 'D'">
          <template slot-scope="scope">
            <a class="txt-color" @click="editVersion(scope.$index)">更多内容编辑 ｜</a>
            <a class="txt-color" v-if="scope.$index != 0" @click="moveUp(scope.$index)">上移 ｜</a>
            <a class="txt-color" v-if="scope.$index != tableData.length - 1" @click="moveDown(scope.$index)">下移 ｜</a>
            <a class="txt-color" @click="delVersion(scope.$index)">删除</a>
          </template>
        </el-table-column>
        <el-table-column min-width="60px" label="操作" header-align="center" align="center" fixed="right" v-else>
          <template slot-scope="scope">
            <a class="txt-color" @click="editVersion(scope.$index)">更多</a>
          </template>
        </el-table-column>
      </el-table>
      <div class="btn-groups">
        <el-button size="mini" type="info" class="btn-common btn-border-gray" @click="$router.go(-1)">返回</el-button>
        <el-button v-if="$route.query.isUse != 'D'" size="mini" type="info" class="btn-common "
          @click="updateReqVersion">修改</el-button>
      </div>
    </div>
    <!-- 弹窗 -->
    <div v-show="!iconVisible" id="template-config">
      <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="740px">
        <template v-if="dialogVisible">
          <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
            <div class="calc-type">
              <el-form-item>
                <span slot="label" style="color: red">*</span>
                <span slot="label">任务结算规则 </span>
                <div style="display:flex;flex-direction:column;text-align: left;">
                  <el-radio style="margin-bottom:10px;" disabled v-model="tableData[currentIndex].settleRule" label="1">
                    按单价结算，完成量*单价结算</el-radio>
                  <el-radio disabled v-model="tableData[currentIndex].settleRule" label="2">按比例结算，当任务量大于0时，按任务量的
                    <el-input :disabled="tableData[currentIndex].settleRule == 1" class="task-precent"
                      v-model="tableData[currentIndex].settlePercent" oninput="value=value.replace(/[^\d]/g,'')" />%结算
                    <el-tooltip class="item" effect="dark"
                      content="例如：某个人发放 7 万元费用，比例配置为40%，只要有做此任务，那么结算金额最高为 2.8万元（7万 * 40%）" placement="right-start"><i
                        class="el-icon-question"></i></el-tooltip>
                  </el-radio>
                </div>
              </el-form-item>
            </div>

            <!-- <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">限定客户区域 </span>
              <div style="display: flex; flex-direction: column; align-items: flex-start; margin-top: 12px">
                <el-radio-group  :disabled="$route.query.isUse == 'D'" v-model="tableData[currentIndex].clientAreaRadio">
                  <el-radio label="本区域">本区域</el-radio>
                  <el-radio label="指定区域">指定区域</el-radio>
                  <el-radio label="不限区域">不限区域</el-radio>
                </el-radio-group>
                <div v-if="tableData[currentIndex].clientAreaRadio == '指定区域'" style="margin-top: 20px">
                  <el-select   :disabled="$route.query.isUse == 'D'" style="width: 400px" v-model="tableData[currentIndex].clientArea"
                    placeholder="选择任务执行时针对的对象，可多选" class="fl" multiple filterable>
                    <el-option v-for="item in clientAreaList" :key="item" :label="item" :value="item"></el-option>
                  </el-select>
                </div>
              </div>
            </el-form-item> -->
            <div class="calc-type">
              <el-form-item>
                <span slot="label" style="color: red">*</span>
                <span slot="label">限定客户区域 </span>
                <div style="display: flex; flex-direction: column; align-items: flex-start;">
                  <el-radio style="margin-bottom:12px;" :disabled="$route.query.isUse == 'D'" label="不限区域"
                    v-model="tableData[currentIndex].clientAreaRadio">不限客户区域</el-radio>
                  <el-radio
                    :style="tableData[currentIndex].clientAreaRadio == '指定区域'?'margin-bottom:0;':'margin-bottom:12px;'"
                    :disabled="$route.query.isUse == 'D'" label="本区域"
                    v-model="tableData[currentIndex].clientAreaRadio">本销售区域客户</el-radio>
                  <el-radio :disabled="$route.query.isUse == 'D'" label="指定区域"
                    v-model="tableData[currentIndex].clientAreaRadio">指定客户区域
                    <div v-if="tableData[currentIndex].clientAreaRadio == '指定区域'"
                      style="margin-left: 14px;display:inline-block">
                      <el-cascader placeholder="请选择" collapse-tags :options="provinceAndCityData"
                        v-model="tableData[currentIndex].clientArea" :props="{ multiple: true, checkStrictly: false }"
                        :disabled="$route.query.isUse == 'D'" filterable ref="cascaderAddr"
                        @change="handleProvinceAndCity">
                      </el-cascader>
                    </div>
                  </el-radio>


                </div>
              </el-form-item>
            </div>
            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">工作内容描述</span>
              <el-tooltip class="tips fl" effect="dark" content="手机端展示" placement="right-start"><i
                  class="el-icon-question"></i></el-tooltip>
              <div class="fl" style="width: 400px">
                <!-- <div class="fl">
                  选择自定义标签:
                  <span style="cursor: pointer; text-decoration: underline; margin: 0 10px"
                    @click="chooseAreaGoods(0)">客户区域</span>
                  <span style="cursor: pointer; text-decoration: underline" @click="chooseAreaGoods(1)">定义品种</span>
                  <span style="cursor: pointer; text-decoration: underline; margin: 0 10px"
                    @click="chooseAreaGoods(2)">总任务量</span>
                  <span style="cursor: pointer; text-decoration: underline" @click="chooseAreaGoods(3)">任务量单位</span>
                </div> -->
                <el-input class="fl" style="width: 400px" type="textarea" :rows="5" :maxlength="200" placeholder="请填写"
                  v-model="tableData[currentIndex].staffTaskNote" disabled>
                </el-input>
              </div>
            </el-form-item>
            <!-- <el-form-item>
              <span slot="label">药企工作要求
                <el-tooltip class="item" effect="dark" content="药企对运营方的工作要求" placement="right-start"><i
                    class="el-icon-question"></i></el-tooltip>
              </span>
              <div class="fl" style="width: 400px">
                <el-input class="fl" style="width: 400px" type="textarea" :rows="5" :maxlength="200" placeholder="请输入"
                  v-model="tableData[currentIndex].tenantWorkNote" disabled>
                </el-input>
              </div>
            </el-form-item> -->
            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">工作内容明细
              </span>
              <el-tooltip class="tips fl" effect="dark" content="手机端、PC端详细展示" placement="right-start"><i
                  class="el-icon-question"></i></el-tooltip>
              <div class="fl" style="width: 400px">
                <el-input class="fl" style="width: 400px" type="textarea" :rows="5" :maxlength="200" placeholder="请填写"
                  v-model="tableData[currentIndex].tenantTaskNote" disabled>
                </el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">任务管理要求

              </span>
              <el-tooltip class="tips fl" effect="dark" content="手机端展示给业务员看的工作要求" placement="right-start"><i
                  class="el-icon-question"></i></el-tooltip>
              <div class="fl" style="width: 400px">
                <el-input class="fl" type="textarea" :rows="5" :maxlength="200" placeholder="请输入"
                  v-model="tableData[currentIndex].staffWorkNote" disabled>
                </el-input>
              </div>
            </el-form-item>

            <!-- <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">任务管理要求
              </span>
              <el-tooltip  class="tips fl" effect="dark" content="手机端展示给业务员看的工作要求"
                  placement="right-start"><i class="el-icon-question"></i></el-tooltip>
              <el-select filterable multiple v-model="tableData[currentIndex].taskTag" placeholder="请选择任务要求"
                style="width: 400px" class="fl" @change="taskTagChange" disabled>
                <el-option v-for="(item, index) in tableData[currentIndex].taskReqList" :key="index"
                  :label="item.paramName" :value="item.paramName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <span slot="label" style="color: white">*</span>
              <span slot="label">
              </span>
              <div class="fl" style="width: 400px; margin-left: 0px">
                <el-input type="textarea" :rows="5" :maxlength="400" placeholder="示例：（系统会自动根据行数增加序号;照片拍摄：门头照+行动轨迹或者门头自拍照或者加时间水印的内部照3选1；系统录入：录入竞品相关数据；文字编辑：不得少于50字"
                  v-model="tableData[currentIndex].staffWorkNote" disabled>
                </el-input>
              </div>
            </el-form-item> -->
            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">任务图标 </span>
              <el-tooltip class="tips fl" effect="dark" content="手机端展示的任务图标" placement="right-start"><i
                  class="el-icon-question"></i></el-tooltip>
              <div class="img-close"
                v-if="tableData[currentIndex].fileList.length != 0 && tableData[currentIndex].fileList[0].url">
                <img class="file-img" :src="tableData[currentIndex].fileList && tableData[currentIndex].fileList[0].url"
                  alt="" srcset="" />
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">任务标签
              </span>
              <el-select collapse-tags style="width: 210px; float: left" v-model="tableData[currentIndex].taskLabel"
                placeholder="请选择标签" filterable class="fl" :multiple-limit="3" multiple>
                <el-option v-for="item in taskLabelListList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <el-input type="input" style="width: 120px; float: left;margin: 0 10px;" :maxlength="6"
                placeholder="新增标签名称" v-model.trim="taskLabelVal" />
              <el-button size="mini" style="float: left; height: 35px;margin-top: 3px;"
                @click="addLable()">新增</el-button>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button size="medium" type="info" @click="moreSure">确 定
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
    <el-dialog title="任务图标选择" class="icon-dialog-wrap" :visible.sync="iconVisible" width="50%">
      <div class="icon-dialog">
        <div class="icon-left">
          <div class="item" :style="activeIcon == index ? 'background:#EDEDED;' : ''" @click="handleClickMenu(index)"
            v-for="(item, index) in iconList" :key="index">
            <el-tooltip :content="item.paramName" placement="top">
              <span>
                {{ item.paramName }}
              </span>
            </el-tooltip>
          </div>
        </div>

        <div class="icon-right">
          <div class="pic" v-for="(item, index) in iconList[activeIcon] &&
          iconList[activeIcon].paramValue &&
          JSON.parse(iconList[activeIcon].paramValue)" :key="index">
            <div class="img-wrap" @click="chooseIcon(item.url)">
              <el-image class="img" :src="item.url" fit="contain" />
              <img :style="chooseURL == item.url ? 'display:block' : 'display:none;'" class="border-img"
                src="@/assets/images/ic_select.png" alt="" />
              <div class="name">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="info" @click="moreSureIcon">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择部门" :visible.sync="visible3" width="70%" center>
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input v-model="filterText" class="ipt-sty mt15" placeholder="请输入部门名称"></el-input>
            <p class="fontC-bbb">组织架构</p>
            <el-tree class="filter-tree" :data="areaData" :props="defaultProps" :filter-node-method="filterNode"
              @check="handleNodeClick1" :check-strictly="true" show-checkbox ref="tree" node-key="guid" v-if="visible3">
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ departmentList.length }}个部门</p>
            <el-button size="medium" type="danger" @click="delDepartment()" class="fr" style="margin-top: 5px">批量删除
            </el-button>
            <el-table :data="departmentList" border height="280px" style="width: 100%"
              @selection-change="handleSelectionChange1">
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column header-align="center" align="center" show-overflow-tooltip prop="organisationName"
                label="名称">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible3 = false">取消</el-button>
        <el-button size="medium" type="info" @click="departmentSure()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择产品" ref="multipleTable" :visible.sync="visible2" width="70%" center>
      <el-row :gutter="24" class="mb30">
        <el-col :span="13">
          <div class="search-area-div w80">产品名称：</div>
          <el-input v-model="pageII.goodsName" class="ipt-sty" placeholder="请输入"></el-input>
        </el-col>
        <el-col :span="3">
          <el-button size="medium" type="info" @click="searchData()">搜索</el-button>
        </el-col>
      </el-row>
      <el-table :data="productInformationList" style="width: 100%" row-key="guid" border
        @selection-change="handleSelectionChange" v-loading="loading" ref="dataTable" @row-click="btn">
        <el-table-column type="selection" :reserve-selection="true"> </el-table-column>
        <el-table-column prop="goodsName" label="产品" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope"> {{ scope.row.goodsName }} </template>
        </el-table-column>
        <el-table-column prop="goodsSpec" label="规格" header-align="center" align="left" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="producer" label="生产企业" header-align="center" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="price" label="单位" header-align="center" align="center">
          <template slot-scope="scope"> {{ scope.row.unitStyle }} </template>
        </el-table-column>
        <el-table-column prop="price" label="单价" header-align="center" align="center">
          <template slot-scope="scope"> {{ scope.row.price | numDigit | numFmt }} </template>
        </el-table-column>
        <el-table-column prop="price" label="是否主品" header-align="center" align="center">
          <template slot-scope="scope"> {{ scope.row.isMain == 'Y' ? '是' : '否' }} </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1" :current-page="pageII.pageIndex" :page-size="pageII.pageSize"
        layout="total, prev, pager, next, jumper" :total="pageII.totalRows">
      </el-pagination>
      <div slot="footer" class="dialog-footer t-right">
        <p class="t-left fl" style="font-size: 14px">
          本次已选择{{ tableData[currentIndex] && tableData[currentIndex].multipleSelection.length }}个产品
        </p>
        <el-button plain size="medium" @click="visible2 = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitForm()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { provinceAndCityData } from 'element-china-area-data'
import store from '@/store';
export default {
  data() {
    return {
      taskPriceModel:1,
      taskLabelListList:[],
      taskLabelVal:'',
      provinceAndCityData:provinceAndCityData,
      serviceTenantGuid: '', //服务商id
      serviceTenantName: '', //服务商名称
      fullscreenLoading: false,
      textTitle: '新增任务大类',
      organisationList: [],
      tenantList: [],
      sendTenantList: [], //委托方
      taskTypeList: [],
      taskContentList: [],
      taskReqList: [],
      taskTotalUnitList: [],
      surveyLabelOptions: [],
      taskPriceUnitList: [],
      clientObjectList: [],
      clientObject: [],
      clientAreaList: [
        '北京',
        '天津',
        '上海',
        '重庆',
        '河北',
        '河南',
        '云南',
        '辽宁',
        '安徽',
        '山东',
        '新疆',
        '江苏',
        '浙江',
        '江西',
        '湖北',
        '广西',
        '甘肃',
        '山西',
        '内蒙古',
        '陕西',
        '吉林',
        '福建',
        '贵州',
        '广东',
        '青海',
        '西藏',
        '四川',
        '宁夏',
        '海南',
        '台湾',
        '黑龙江',
        '湖南',
      ],
      clientAreaRadio: '本区域',
      clientAreaLabel:[],
      clientArea: '',
      templateName: '',
      taskType: '',
      taskContentName: '',
      tenantName: '',
      taskTag: [],
      taskTotal: '',
      taskTotalUnit: '',
      taskTotalUnitGuid:'',

      taskPrice: '',
      taskPriceUnit: '',
      taskPriceUnitGuid:'',
      tenantTaskPrice: '', //药企报价
      tenantTaskPriceUnit: '',
      tenantTaskPriceUnitGuid:'',
      taskNote: '',
      height: window.innerHeight - 260,
      right: 'right',
      tableData: [
        {
          departmentData: [], //部门
          taskType: '', //任务大类
          taskTypeGuid: '', //任务大类Guid
          taskContentName: '', //任务名称
          taskContentGuid: '', //任务名称Guid
          taskContentList: [], //任务名称list
          menuUrl: '', // 系统功能路径
          taskContentJson:'',
          menuName: '', //系统功能
          isAllowTenantUse: '',
          taskTotal: '',
          taskTotalUnit: '',
          taskTotalUnitGuid:'',

          taskPrice: '',
          taskPriceUnit: '',
          taskPriceUnitGuid:'',

          discountRatio:'',
          tenantMinPrice:'',
          tenantMaxPrice:'',
          staffBasePrice:'',
          ruleCoefficient:'',

          tenantTaskPrice: '', //药企报价
          tenantTaskPriceUnit: '',
          tenantTaskPriceUnitGuid:'',

          settleRule: "1", //1单价 2比例
          settlePercent: null,

          isAskClock: '', //是否要求打卡 是/否

          isAskPhoto: '', //是否要求拍照 是/否
          minAskPhoto: '', //最少要求拍照数量

          isAskUpload: '', //是否要求上传资料 是/否
          minAskUpload: '', //最少上传资料数量

          isOpenMaxTask: 'Y', //是否开启超量上限拦截
          maxTaskValue: 0,  // 超量限制

          taskTotal: '',
          taskTotalUnit: '',
          taskTag: '', //任务要求
          multipleSelection: [], //品种
          calcType: '系统计算',
          tenantWorkNote: '', //药企工作要求
          tenantTaskNote: '', //药企任务文案
          staffWorkNote: '', //运营工作要求
          staffTaskNote: '', //运营任务文案
          clientAreaRadio: '不限区域',
          clientArea: '',
          clientAreaLabel:[],
          fileList: [],
          taskReqList: [],
          taskLabel:[],
        },
      ],
      dialogVisible: false,

      visible3: false,
      area: [],
      departmentList: [],
      departmentData: '',
      areaData: [],
      delList: [],
      filterText: '',
      defaultProps: {
        id: 'guid',
        label: 'organisationName',
        children: 'children',
        disabled: this.disabledTreeNode,
      },

      visible2: false,
      pageII: {
        pageIndex: 1,
        tenantGuid: '',
        pageSize: 10,
        goodsName: '',
        isPrescription: '',
        staffGuid: '',
        totalPage: 0,
        totalRows: 0,
      },
      productInformationList: [],
      multipleSelection: [],

      loading: false,
      provinceArray: [
        { name: '北京', code: 110000 },
        { name: '天津', code: 120000 },
        { name: '河北', code: 130000 },
        { name: '山西', code: 140000 },
        { name: '内蒙古', code: 150000 },
        { name: '辽宁', code: 210000 },
        { name: '吉林', code: 220000 },
        { name: '黑龙江', code: 230000 },
        { name: '上海', code: 310000 },
        { name: '江苏', code: 320000 },
        { name: '浙江', code: 330000 },
        { name: '安徽', code: 340000 },
        { name: '福建', code: 350000 },
        { name: '江西', code: 360000 },
        { name: '山东', code: 370000 },
        { name: '河南', code: 410000 },
        { name: '湖北', code: 420000 },
        { name: '湖南', code: 430000 },
        { name: '广东', code: 440000 },
        { name: '广西', code: 450000 },
        { name: '海南', code: 460000 },
        { name: '重庆', code: 500000 },
        { name: '四川', code: 510000 },
        { name: '贵州', code: 520000 },
        { name: '云南', code: 530000 },
        { name: '西藏', code: 540000 },
        { name: '陕西', code: 610000 },
        { name: '甘肃', code: 620000 },
        { name: '青海', code: 630000 },
        { name: '宁夏', code: 640000 },
        { name: '新疆', code: 650000 },
      ],
      currentIndex: 0, //当前操作行
      calcTypeList: ['系统计算', '固定量人均', '按学术活动计划', '不限量'],
      detail: null,
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      iconVisible: false,
      iconList: [],
      activeIcon: 0,
      chooseURL: null,
    };
  },
  created() {
    let userInfo = JSON.parse(localStorage.userInfo);
    this.serviceTenantName = userInfo.tenantName;
    this.serviceTenantGuid = localStorage.guid;
    this.getHeartDictList();
    this.getTenantList();
    this.getSendTenantList();
    this.getTaskTypeList();
    this.getTaskTotalUnitList();
    this.getTaskPriceUnitList();
    this.getCustomerType();
    this.getIconList();
    this.getLabelOrCreate();
    if (!this.$route.query.guid) return;
    this.getDetail();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  computed:{
      tableHeight(){
        return this.tableData.length>8?'600px':'';
      }
    },
  methods: {
    // 更新标签
    updateLabels(value, row) {
      if (value?.length > 3) {
        this.$message.warning('最多只能选择3个标签');
        
        // 保存当前行的原始值
        const originalValue = [...(row.surveyLabelList || [])];
        
        if (originalValue.length >= 3) {
          // 已经有3个，恢复原来的值
          this.$nextTick(() => {
            // 使用 Vue.set 确保响应式更新
            this.$set(row, 'surveyLabelList', originalValue);
          });
        } else {
          // 还没有3个
          this.$nextTick(() => {
            this.$set(row, 'surveyLabelList', value);
          });
        }
      } else {
        this.$set(row, 'surveyLabelList', value || []);
      }
    },
    async getHeartDictList() {
      const params = {
        name: "项目标签",
      };
      const { data } = await this.api.get(
        `/${serverConfig.msSalesPerformService}/common/get-heart-dict`,
        params
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.surveyLabelOptions = data.data.map(item => {
        return {
          ...item,
          disabled: true,
        }
      })
      this.surveyLabelMap = this.getSurveyLabelMap(data.data);
    },
    handleProvinceAndCity() {
      this.$nextTick(() => {
        let arr = this.$refs['cascaderAddr'].getCheckedNodes()
        let newList = [];
        arr.forEach(item => {
          if (item.level == 1 && item.label == '北京市' || item.level == 1 && item.label == '上海市' || item.level == 1 && item.label == '重庆市' || item.level == 1 && item.label == '天津市') {
            newList.push(item.label)
          } else if (item.level == 2 && item.label != '市辖区' && item.label != '县') {
            newList.push(item.label)
          }
        })
        this.tableData[this.currentIndex].clientAreaLabel = newList
      })
    },
    handleSelecTaskPriceUnit(value, state, index) {
      let taskPriceUnitList = this.taskPriceUnitList;
      let labelItem = taskPriceUnitList.filter(item=>item.guid==value)
      if (state == 0) {
        this.tableData[index].taskPriceUnitGuid = value;
      }
      if (state == 1) {
        this.tableData[index].tenantTaskPriceUnitGuid = value;
      }
     
      this.tableData[index].taskPriceUnit = labelItem[0].paramValue;
      this.tableData[index].tenantTaskPriceUnit = labelItem[0].paramValue;
    },
    handleSelecTaskTotalUnit(value,index){
      let taskTotalUnitList = this.taskTotalUnitList;
      let labelItem = taskTotalUnitList.filter(item=>item.guid==value)
      console.log(labelItem)
      this.tableData[index].taskTotalUnit = labelItem[0].paramValue;
    },
    moveDown(index) {
      var tableData = JSON.parse(JSON.stringify(this.tableData));
      var temp = tableData[index];
      var temp_1 = tableData[index + 1];
      tableData[index] = temp_1;
      tableData[index + 1] = temp;
      this.tableData = tableData;
      this.$forceUpdate();
    },
    moveUp(index) {
      var tableData = JSON.parse(JSON.stringify(this.tableData));
      var temp = tableData[index];
      var temp_1 = tableData[index - 1];
      tableData[index] = temp_1;
      tableData[index - 1] = temp;
      this.tableData = tableData;
      this.$forceUpdate();
    },
    taskTagChange() {
      var index = this.currentIndex;
      var taskTagList = this.tableData[index].taskTag;
      var taskReqList = this.tableData[index].taskReqList;
      var list = [];
      taskTagList.forEach((el) => {
        taskReqList.forEach((item) => {
          if (el == item.paramName) {
            list.push(item.paramValue);
          }
        });
      });
      this.tableData[index].staffWorkNote = list.join('\n');
    },
    isContainOrg(arr, guid) {
      if (!arr.length) return 0;
      let flag = arr.findIndex((one) => {
        return one == guid;
      });
      if (flag == -1) {
        return 0;
      } else {
        return 1;
      }
    },
    disabledTreeNode(data, node) {
      let list = this.departmentList;
      if (list.length) {
        let flag = 0;
        let parentGuids = data.parentGuids ? data.parentGuids : [];
        for (let i = 0; i < list.length; i++) {
          let checkedParentGuids = list[i].parentGuids ? list[i].parentGuids : [];
          if (this.isContainOrg(parentGuids, list[i].guid)) {
            flag = 1;
            break;
          } else if (this.isContainOrg(checkedParentGuids, data.guid)) {
            flag = 1;
            break;
          } else {
            flag = 0;
          }
        }
        return flag > 0;
      } else {
        return false;
      }
    },
    searchData() {
      this.getData();
    },
    moreSure() {
      var index = this.currentIndex;
      var tableData = this.tableData;
      if (tableData[index].settleRule == 2 && !tableData[index].settlePercent) {
        this.$message.error('请输入结算比例');
        return;
      }
      if (!tableData[index].tenantTaskNote) {
        this.$message.error('请填写药企任务文案');
        return;
      }
      if (!tableData[index].staffTaskNote) {
        this.$message.error('请填写业务员任务文案');
        return;
      }
      if (tableData[index].fileList.length == 0) {
        this.$message.error('请上传任务图标');
        return;
      }
      this.dialogVisible = false;
    },
    handleChooseGoods(index) {
      if (this.$route.query.isUse == 'D') return;
      this.visible2 = true;
      this.currentIndex = index;
    },
    getGoodsName(list) {
      var strList = [];
      list.forEach((item) => {
        strList.push(item.goodsName);
      });
      return strList.join('、');
    },
    submitForm() {
      this.visible2 = false;
    },
    getDetail() {
      var req = {
        templateGuid: this.$route.query.guid,
        pageSize: -1,
        pageIndex: 1
      };
      var self = this;
      this.tableData = [];
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/template/get-detail`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          var detail = res.data.data;
          var detailList = detail.detailList;
          self.taskPriceModel = detailList[0].taskPriceModel;
          self.templateName = detail.templateName;
          self.tenantName = detail.tenantName;

          //部门
          var departmentList = [];
          var organisationInfo = JSON.parse(detail.organisationInfo);
          organisationInfo.forEach((item) => {
            departmentList.push({
              guid: item.guid,
              organisationName: item.name,
            });
          });
          this.departmentList = departmentList;

          detailList.forEach((el, ky) => {
            var tableItem = {
              surveyLabelList: el.surveyLabelList || [],// 标签
              departmentData: [], //部门
              taskType: '', //任务大类
              taskTypeGuid: '', //任务大类Guid
              taskContentName: '', //任务名称
              taskContentList: [], //任务名称list
              taskContentGuid: '', //任务名称Guid
              menuUrl: '', // 系统功能路径
              taskContentJson:"",
              menuName: '', //系统功能
              isAllowTenantUse: '',

              taskTotal: '',//任务总量
              taskTotalUnit: '',
              taskTotalUnitGuid:'',

              taskPrice: '',//业务员报价
              taskPriceUnit: '',
              taskPriceUnitGuid:'',

              discountRatio:'',
              tenantMinPrice:'',
              tenantMaxPrice:'',
              staffBasePrice:'',
              ruleCoefficient:'',

              tenantTaskPrice: '', //药企报价
              tenantTaskPriceUnit: '',
              tenantTaskPriceUnitGuid:'',
             

              settleRule: "1", //1单价 2比例
              settlePercent: null,
              guid: '',
              isAskClock: '', //是否要求打卡 是/否

              isAskPhoto: '', //是否要求拍照 是/否
              minAskPhoto: '', //最少要求拍照数量

              isAskUpload: '', //是否要求上传资料 是/否
              minAskUpload: '', //最少上传资料数量
              taskTag: '', //任务要求
              multipleSelection: [], //品种
              calcType: '系统计算',
              tenantWorkNote: '', //药企工作要求
              tenantTaskNote: '', //药企任务文案
              staffWorkNote: '', //运营工作要求
              staffTaskNote: '', //运营任务文案
              taskLabel:'',
              clientAreaRadio: '本区域',
              clientArea: [],
              clientAreaLabel:[],
              fileList: [],
              isTeamLeader: '',
              menuRemark: '',
              parentTemplateDetailName: '',
              parentTemplateDetailGuid: ''
            };
            tableItem.guid = el.guid;
            tableItem.isTeamLeader = el.isTeamLeader;
            //任务大类
            tableItem.taskType = el.taskType;
            tableItem.taskTypeGuid = el.taskTypeGuid;
            // self.getTaskContentList(el.taskType, ky);

            //任务名称
            tableItem.taskContentType = el.taskContentType;
            tableItem.taskContentName = el.taskContentName;
            tableItem.taskContentGuid = el.taskContentGuid;
            this.getTaskReqList(el.taskContentGuid, ky);

            tableItem.menuRemark = el.menuRemark;
            tableItem.menuUrl = el.menuUrl;
            tableItem.taskContentJson =el.taskContentJson
            tableItem.menuName = el.menuName;
            tableItem.isAllowTenantUse = el.isAllowTenantUse;

            //计算方式
            tableItem.calcType = el.taskTotalType;

            //药企价格
            tableItem.tenantTaskPrice = el.tenantTaskPrice;

            tableItem.discountRatio = el.discountRatio;
            tableItem.tenantMinPrice = el.tenantMinPrice;
            tableItem.tenantMaxPrice = el.tenantMaxPrice;
            tableItem.staffBasePrice = el.staffBasePrice;
            tableItem.ruleCoefficient = el.ruleCoefficient;

            tableItem.tenantTaskPriceUnit = el.tenantTaskPriceUnit.replace(' ','');
            tableItem.tenantTaskPriceUnitGuid = el.tenantTaskPriceUnitGuid;

            //业务员价格
            tableItem.taskPrice = el.taskPrice;
            tableItem.taskPriceUnit = el.taskPriceUnit.replace(' ','');
            tableItem.taskPriceUnitGuid = el.taskPriceUnitGuid;

            tableItem.settleRule = el.settleRule;
            tableItem.settlePercent = el.settlePercent;

            //是否要求打卡
            tableItem.isAskClock = el.isAskClock;

            //是否要求拍照
            tableItem.isAskPhoto = el.isAskPhoto;

            //最少要求拍照数量
            tableItem.minAskPhoto = el.minAskPhoto;

            //是否要求上传资料
            tableItem.isAskUpload = el.isAskUpload;

            //最少上传资料数量
            tableItem.minAskUpload = el.minAskUpload;

            tableItem.isOpenMaxTask = el.isOpenMaxTask || 'Y';
            tableItem.maxTaskValue = el.maxTaskValue || 0;

            //平台任务名称
            tableItem.parentTemplateDetailName = el.parentTemplateDetailName;
            tableItem.parentTemplateDetailGuid = el.parentTemplateDetailGuid;

            //任务量设置
            tableItem.taskTotal = el.taskTotal;
            tableItem.taskTotalUnit = el.taskTotalUnit;
            tableItem.taskTotalUnitGuid = el.taskTotalUnitGuid;

            //商品
            var multipleSelection = [];
            var goodsInfo = el.goodsInfo ? JSON.parse(el.goodsInfo) : [];
            if (goodsInfo.length != 0) {
              goodsInfo.forEach((i) => {
                multipleSelection.push({
                  guid: i.guid,
                  goodsName: i.name,
                  unitStyle: i.goodsUnit,
                  goodsSpec: i.goodsSpec,
                });
              });
            }
            tableItem.multipleSelection = multipleSelection;
            //客户区域
            // var clientArea = JSON.parse(el.clientArea);
            // clientArea.forEach((item) => {
            //   if (item.name == '本区域' || item.name == '不限区域') {
            //     tableItem.clientAreaRadio = item.name;
            //   } else {
            //     tableItem.clientAreaRadio = '指定区域';
            //     tableItem.clientArea.push([item.provinceCode,item.guid]);
            //     tableItem.clientAreaLabel.push(item.name)
            //   }
            // });

            //药企任务文案 、药企工作要求 运营任务文案 运营工作文案
            tableItem.staffWorkNote = JSON.parse(el.staffWorkNote).join('\n');;
            tableItem.staffTaskNote = el.staffTaskNote;
            tableItem.tenantWorkNote = el.tenantWorkNote;
            tableItem.tenantTaskNote = el.tenantTaskNote;

            //图标
            tableItem.fileList = JSON.parse(el.taskIcon);

            //任务要求
            tableItem.taskTag = el.taskTag ? JSON.parse(el.taskTag) : null;


            tableItem.taskLabel = el.taskLabel ? JSON.parse(el.taskLabel) : null;


            self.tableData.push(tableItem);


          });
          self.detail = detail;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //选择部门
    handleChooseDepart() {
      if (this.$route.query.isUse == 'D') return;
      this.visible3 = true;
    },
    getCustomerType() {
      let that = this;
      that.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${localStorage.guid}&code=DYKHDX`,
        )
        .then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            let arr = [];
            data.forEach((item) => {
              arr.push(item.name);
            });
            that.clientObjectList = arr;
          }
        });
    },

    chooseAreaGoods(type) {
      return;
      var currentIndex = this.currentIndex;
      var tableDataItem = this.tableData[currentIndex];
      if (
        (type == 0 && tableDataItem.clientAreaRadio == '本区域') ||
        (type == 0 && tableDataItem.clientAreaRadio == '不限区域')
      ) {
        this.tableData[currentIndex].tenantTaskNote = tableDataItem.tenantTaskNote + tableDataItem.clientAreaRadio;
      }
      if (
        type == 0 &&
        tableDataItem.clientAreaRadio == '指定区域' &&
        tableDataItem.clientArea &&
        tableDataItem.clientArea.length != 0
      ) {
        var list = [];
        tableDataItem.clientArea.forEach((item) => {
          list.push(item);
        });
        this.tableData[currentIndex].tenantTaskNote = tableDataItem.tenantTaskNote + list.join('、');
      }

      if (type == 1 && tableDataItem.multipleSelection && tableDataItem.multipleSelection.length != 0) {
        var multipleSelection = tableDataItem.multipleSelection;
        var list = [];
        multipleSelection.forEach((i) => {
          list.push(i.goodsName);
        });
        this.tableData[currentIndex].tenantTaskNote = this.tableData[currentIndex].tenantTaskNote + list.join('、');
      }
      if (type == 2) {
        this.tableData[currentIndex].tenantTaskNote = this.tableData[currentIndex].tenantTaskNote + '#总任务量#';
      }
      if (type == 3 && tableDataItem.taskTotalUnit) {
        this.tableData[currentIndex].tenantTaskNote =
          this.tableData[currentIndex].tenantTaskNote + tableDataItem.taskTotalUnit;
      }
    },

    getDeliverName(res) {
      var list = res;
      var strList = [];
      if (list.length == 0) return;
      list.forEach((item) => {
        strList.push(item.organisationName);
      });
      return strList.join('、');
    },
    getTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: this.$getValueListByKey('上游客户分类'),
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records;
          var tenantList = this.tenantList;
          var tableData = this.tableData;
          tenantList.forEach((item) => {
            if (item.tenantName == this.tenantName) {
              this.getData();
              this.getOrganisation(item.guid);
              this.tableData = tableData;
            }
          });
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getSendTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getTaskTypeList() {
      let req = {
        pageIndex: 1,
        pageSize: -1,
        bizType: '任务大类',
        tenantGuid: localStorage.guid,
      };
      let self = this;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.taskTypeList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTaskContentList(taskType, currentIndex) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        taskType: taskType,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/content/get-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData[currentIndex].taskContentList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTaskReqList(paramValue1, currentIndex) {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        bizType: '工作要求',
        tenantGuid: localStorage.guid,
        paramValue1: paramValue1,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData[currentIndex].taskReqList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTaskTotalUnitList() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        bizType: '任务单位',
        paramName: '任务总量单位', //单位类型
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.taskTotalUnitList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getTaskPriceUnitList() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        bizType: '任务单位',
        paramName: '任务价格单位', //单位类型
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.taskPriceUnitList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectTaskType(taskType, currentIndex) {
      this.tableData[currentIndex].taskContentName = '';
      this.getTaskContentList(taskType, currentIndex);
    },
    handleSelectContentName(row, currentIndex) {
      var taskContentList = row.taskContentList;
      var taskContentName = row.taskContentName;
      taskContentList.forEach((item) => {
        if (item.taskContentName == taskContentName) {
          this.tableData[currentIndex].menuName = item.menuName;
          this.tableData[currentIndex].menuUrl = item.menuUrl;
          this.tableData[currentIndex].taskContentJson = item.taskContentJson;
          this.tableData[currentIndex].isTeamLeader = item.isTeamLeader;
          this.tableData[currentIndex].isAllowTenantUse = item.isAllowTenantUse;
          this.getTaskReqList(item.guid, currentIndex);
        }
      });

    },
    handleSelectFactory() {
      var tenantList = this.tenantList;
      var tableData = this.tableData;
      tenantList.forEach((item) => {
        if (item.tenantName == this.tenantName) {
          this.getData();
          this.getOrganisation(item.guid);
          this.departmentList = [];
          this.tableData = tableData;
        }
      });
    },
    delVersion(index) {
      this.fullscreenLoading = true;
      this.api.get(`/${serverConfig.msSalesPerformService}/task-set/template/check-remove-detail?guid=${this.tableData[index].guid}&templateGuid=${this.$route.query.guid}`).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.tableData.splice(index, 1);
        } else {
          this.$message.error(res.data.msg);
        }
      });

    },
    editVersion(index) {
      this.textTitle = this.tableData[index].taskContentName
        ? `【${this.tableData[index].taskContentName}】编辑`
        : '任务名称编辑';
      this.dialogVisible = true;
      this.currentIndex = index;
    },

    updateReqVersion() {
      var self = this;
      var organisationInfo = [];
      if (!this.tenantName) {
        self.$message.error('请选择下发药企');
        return;
      }
      if (!this.templateName) {
        self.$message.error('请输入模版名称');
        return;
      }
      if (this.departmentList.length == 0) {
        self.$message.error('请选择执行部门');
        return;
      }
      var departmentList = this.departmentList;
      departmentList.forEach((item) => {
        organisationInfo.push({
          guid: item.guid,
          name: item.organisationName,
        });
      });
      var tableData = this.tableData;
      var detailList = [];
      try {
        tableData.forEach((el, orderIndex) => {
          var detail = {
            surveyLabelList: el.surveyLabelList || [],
            guid: el.guid || null,
            taskContentName: '', //任务名称名称
            taskContentGuid: '', //任务名称GUID
            taskContentType: '', //任务名称类别
            taskType: '', //任务大类
            taskTypeGuid: '', //任务大类Guid

            taskTotal: '', //任务总量
            taskTotalUnit: '', //任务总量单位
            taskTotalUnitGuid:'',

            taskPrice: '', //任务价格
            taskPriceUnit: '',
            taskPriceUnitGuid:'',

            tenantTaskPrice: '', //药企价格
            tenantTaskPriceUnit: '',
            tenantTaskPriceUnitGuid:'',

            discountRatio:'',
            tenantMinPrice:'',
            tenantMaxPrice:'',
            staffBasePrice:'',
            ruleCoefficient:'',

            menuUrl: '', //菜单地址
            taskContentJson:'',
            menuName: '', //菜单名称
            isAllowTenantUse: '',
            taskTotalType: '', //任务总量类型(????)

            staffWorkNote: '', //业务员工作要求
            staffTaskNote: '', //业务员任务文案
            tenantWorkNote: '', //药企工作要求
            tenantTaskNote: '', //药企任务文案
            countRule: '', //统计规则
            organisationInfo: '', //下发部门json
            clientObject: null, //客户对象json
            clientArea: '', //客户区域json
            goodsInfo: '', //商品信息json
            taskIcon: '', //	string任务图标json
            settleRule: '',
            settlePercent: '',

            isAskClock: '', //是否要求打卡 是/否
            isAskPhoto: '', //是否要求拍照 是/否
            minAskPhoto: '', //最少要求拍照数量
            isAskUpload: '', //是否要求上传资料 是/否
            minAskUpload: '', //最少上传资料数量
            isOpenMaxTask: 'Y', //是否开启超量上限拦截
            maxTaskValue: 0,  // 超量限制
            orderIndex: orderIndex + 1,
            isTeamLeader: 'N',
            parentTemplateDetailName: '',
            parentTemplateDetailGuid: '',

            taskLabel:''

          };
          detail.parentTemplateDetailName = el.parentTemplateDetailName;
          detail.parentTemplateDetailGuid = el.parentTemplateDetailGuid;
          detail.isTeamLeader = el.isTeamLeader;
          //执行部门

          detail.organisationInfo = JSON.stringify(organisationInfo);

          //任务大类
          detail.taskType = el.taskType;
          this.taskTypeList.forEach((item) => {
            if (item.paramName == el.taskType) {
              detail.taskTypeGuid = item.guid;
            }
          });
          if (!el.taskType) {
            throw new Error('请选择任务大类');
          }

          //任务名称
          detail.taskContentGuid = el.taskContentGuid;
          detail.menuUrl = el.menuUrl;
          detail.taskContentJson = el.taskContentJson;
          detail.menuName = el.menuName;
          detail.isAllowTenantUse = el.isAllowTenantUse
          detail.taskContentType = el.taskContentType;
          detail.taskContentName = el.taskContentName;
          detail.clientObject = el.clientObject;
          detail.menuRemark = el.menuRemark;

          if (!el.taskContentName) {
            throw new Error('请选择任务名称');
          }

          detail.tenantTaskPrice = el.tenantTaskPrice;
          detail.tenantTaskPriceUnit = el.tenantTaskPriceUnit;
          detail.tenantTaskPriceUnitGuid = el.tenantTaskPriceUnitGuid;

          detail.discountRatio = el.discountRatio;
          detail.tenantMinPrice = el.tenantMinPrice;
          detail.tenantMaxPrice = el.tenantMaxPrice;
          detail.staffBasePrice = el.staffBasePrice;
          detail.ruleCoefficient = el.ruleCoefficient;

          if (this.taskPriceModel == 1 && !el.tenantTaskPrice) {
            throw new Error('请填写药企报价');
          }
          if (this.taskPriceModel == 2 && (!el.tenantMinPrice || !el.tenantMaxPrice)) {
            throw new Error('请填写药企报价');
          }
          if (!el.tenantTaskPriceUnitGuid) {
            throw new Error('请填写药企报价单位');
          }

          //业务员报价、业务员报价单位
          detail.taskPrice = el.taskPrice;
          detail.taskPriceUnit = el.taskPriceUnit;
          detail.taskPriceUnitGuid = el.taskPriceUnitGuid;
          if (!el.taskPrice) {
            throw new Error('请填写业务员报价');
          }
          if (!el.taskPriceUnitGuid) {
            throw new Error('请填写业务员报价单位');
          }

          //标准量、标准量单位
          detail.taskTotal = null;
          detail.taskTotalUnit = el.taskTotalUnit;
          detail.taskTotalUnitGuid = el.taskTotalUnitGuid;
          if (!el.taskTotalUnitGuid) {
            throw new Error('请选择任务量单位');
          }

          if (el.isOpenMaxTask == 'Y') {
            if (el.maxTaskValue >= 0 && el.maxTaskValue <= 100) {
              detail.isOpenMaxTask = 'Y';
              detail.maxTaskValue = +el.maxTaskValue;
            } else {
              throw new Error('请填写正确上限百分比');
            }
          } else {
            detail.isOpenMaxTask = 'N';
            detail.maxTaskValue = 0;
          }
          detail.settleRule = el.settleRule;
          detail.settlePercent = el.settleRule == 1 ? null : +el.settlePercent

          if (!el.surveyLabelList?.length) {
            throw new Error('请选择标签');
          }

          detail.isAskClock = el.isAskClock;

          detail.isAskPhoto = el.isAskPhoto;

          detail.minAskPhoto = el.minAskPhoto;
          if (!el.minAskPhoto && el.isAskPhoto == '是') {
            throw new Error('请填写最少拍照数量');
          }
          detail.isAskUpload = el.isAskUpload;
          // if (!el.isAskUpload) {
          //   throw new Error('请选择是否上传资料');
          // }
          detail.minAskUpload = el.minAskUpload;
          if (!el.minAskUpload && el.isAskUpload == '是') {
            throw new Error('请填写最少上传资料数');
          }



          //药企任务文案 、药企工作要求 运营任务文案 运营工作文案
          detail.staffWorkNote = JSON.stringify(el.staffWorkNote.split('\n'));
          detail.staffTaskNote = el.staffTaskNote;
          detail.tenantWorkNote = el.tenantWorkNote;
          detail.tenantTaskNote = el.tenantTaskNote;
          if (!el.tenantTaskNote) {
            throw new Error('请至【更多内容编辑】中填写药企任务文案');
          }
          if (!el.staffTaskNote) {
            throw new Error('请至【更多内容编辑】中填写运营方任务文案');
          }
          if (!el.staffWorkNote) {
            throw new Error('请至【更多内容编辑】中填写运营方工作要求');
          }

          //客户区域
          var clientArea = [];
          if (el.clientAreaRadio == '本区域' || el.clientAreaRadio == '不限区域') {
            clientArea.push({
              name: el.clientAreaRadio,
              guid: '',
            });
          } else {
            if (!el.clientArea.length) {
              throw new Error('请选择客户区域');
            }
            el.clientArea.forEach((item,index) => {
              clientArea.push({
                name: el.clientAreaLabel[index],
                guid: item[1],
                provinceCode: item[0]
              });
            });
          
          }
       
          detail.clientArea = JSON.stringify(clientArea);

          //商品
          var goodsInfo = [];
          if (el.multipleSelection && el.multipleSelection.length != 0) {
            el.multipleSelection.forEach((i) => {
              goodsInfo.push({
                name: i.goodsName,
                guid: i.guid,
                goodsCount: Math.ceil(detail.taskTotal / el.multipleSelection.length),
                goodsUnit: i.unitStyle,
                goodsSpec: i.goodsSpec,
              });
            });
            detail.goodsInfo = goodsInfo.length == 0 ? null : JSON.stringify(goodsInfo);
          } else {
            detail.goodsInfo = null;
          }
          //任务要求
          detail.taskTag = el.taskTag && el.taskTag.length ? JSON.stringify(el.taskTag) : null;

          //任务图标
          detail.taskIcon = JSON.stringify(el.fileList);
          if (el.fileList && el.fileList.length == 0) {
            throw new Error('请至【更多内容编辑】中上传任务图标');
          }

          //规则
          self.taskTotalUnitList.forEach((item) => {
            if (item.guid == el.taskTotalUnitGuid) {
              detail.countRule = item.paramValue1;
            }
          });

          //任务总量类型
          detail.taskTotalType = el.calcType;


          detail.taskLabel = el.taskLabel && el.taskLabel.length ? JSON.stringify(el.taskLabel) : null,

          detailList.push(detail);
        });
      } catch (e) {
        console.log(e);
        this.$message.error(e.message);
        return;
      }
      let tenantList = this.tenantList;
      let tenantGuid;
      tenantList.forEach((item) => {
        if (item.tenantName == this.tenantName) {
          tenantGuid = item.guid;
        }
      });
      if (detailList.length == 0) {
        self.$message.error('请添加任务');
        return;
      }
      var req = {
        guid: this.detail.guid,
        templateName: this.templateName,
        tenantName: this.tenantName,
        tenantGuid,
        detailList,
        serviceTenantName: this.serviceTenantName,
        serviceTenantGuid: this.serviceTenantGuid,
        organisationInfo: JSON.stringify(organisationInfo),
        isSuper: 'N',
        superState: 'Y',
        isUse: 'Y',
      };
      self.fullscreenLoading = true;

      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/template/edit`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('编辑成功');
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    //获取组织
    getOrganisation(guid) {
      let self = this;
      let sendTenantGuid = guid;
      let tenantGuid = localStorage.guid;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail-from-servicetenant?tenantGuid=${tenantGuid}&sendTenantGuid=${sendTenantGuid}`,
        ).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaData = res.data.data;
          } else {
            self.$message.error(res.data.msg);
            self.areaData = [];
            self.tableData = [];
          }
        });
    },
    //部门弹框选择
    handleNodeClick1(data) {
      this.departmentList = this.$refs.tree.getCheckedNodes(false);
      this.$forceUpdate();
    },
    //确定选择部门
    departmentSure() {
      if (this.departmentList.length == 0) {
        this.$message.error('请勾选部门！');
        return;
      }
      this.visible3 = false;
    },
    handleSelectionChange1(val) {
      let self = this;
      self.delList = val;
    },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选部门！');
        return;
      }
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.guid == j.guid) {
            self.departmentList.splice(index, 1);
          }
        });
      });
      self.delList.forEach(function (m) {
        self.area.forEach(function (n, idn) {
          if (JSON.parse(n).guid == m.guid) {
            self.area.splice(idn, 1);
          }
        });
      });
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    //获取产品数据
    getData() {
      let self = this;
      let tenantList = this.tenantList;
      let tenantGuid;
      tenantList.forEach((item) => {
        if (item.tenantName == this.tenantName) {
          tenantGuid = item.guid;
        }
      });
      self.pageII.tenantGuid = tenantGuid;

      self.api.postJson(`/${serverConfig.msProductService}/goods/data/get`, self.pageII).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.productInformationList = res.data.data.records;
          self.pageII.totalPage = res.data.data.totalPages;
          self.pageII.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handleRemove(file) {
      let self = this;
      self.tableData[this.currentIndex].fileList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.tableData[self.currentIndex].fileList.splice(ind, 1);
        }
      });
    },
    uploadImage(file) {
      let self = this;
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '任务图',
              url: res.data.data,
            };
            self.tableData[self.currentIndex].fileList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    handleSizeChange1(val) {
      let self = this;
      self.pageII.pageSize = val;
      this.getData();
    },
    handleCurrentChange1(val) {
      let self = this;
      self.pageII.pageIndex = val;
      this.getData();
    },
    handleSelectionChange(val) {
      let self = this;
      self.tableData[this.currentIndex].multipleSelection = val;
    },
    btn(row, col, event) {
      row.flag = !row.flag;
      this.$refs.dataTable.toggleRowSelection(row, row.flag);
    },
    //获取图标数据
    getIconList() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0,
        bizType: '图标管理',
        paramName: '',
        // tenantGuid: localStorage.guid,
        // tenantName: JSON.parse(localStorage.userInfo).tenantName,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.iconList = res.data.data.records;
          self.activeIcon = 0;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleClickMenu(index) {
      this.activeIcon = index;
    },
    chooseIcon(url) {
      this.chooseURL = url;
    },
    delPic() {
      this.tableData[this.currentIndex].fileList = [];
      this.$forceUpdate();
    },
    addPic() {
      if (this.tableData[this.currentIndex].fileList.length != 0) {
        this.$message.error('任务图标只能选择一个');
        return;
      }
      this.iconVisible = true;
    },
    moreSureIcon() {
      if (!this.chooseURL) {
        this.$message.error('请选择任务图标');
        return;
      }
      this.tableData[this.currentIndex].fileList = [
        {
          name: '任务图',
          url: this.chooseURL,
        },
      ];

      this.iconVisible = false;
      this.$forceUpdate();
    },
    getLabelOrCreate() {
      let that = this;
      that.api.get(
        `/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=任务标签`,
      ).then((resp) => {
        const { data } = resp
        console.log(data)
        // 字典分类【任务标签】不存在，则需要新增
        if (data.msg != 'success') {
          that.api.postJson(
            `/${serverConfig.msConfigureService}/dict/save-class`,
            {
              "guid": '',
              "dictTypeName": "任务标签",
              "orderNum": 0
            }
          ).then((res) => {
          });
        } else {
          that.api.get(`/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=任务标签`).then((res) => {
            let list = res.data.data || [];
            this.taskLabelListList = [];
            list.forEach(item => {
              if(item.text){
                this.taskLabelListList.push(item.text)
              }
            })
            this.$forceUpdate();
          });

        }
      });
    },
    addLable() {
      if (!this.taskLabelVal) {
          this.$message.error('请填写标签')
          return;
      }
      if(this.tableData[this.currentIndex].taskLabel.length==3){
          this.$message.error('最多添加三个！')  
          return;
      }
      this.api.postJson(
        `/${serverConfig.msConfigureService}/dict/save-dict`,
        {
          "dicValue": this.taskLabelVal,
          "dicName": this.taskLabelVal,
          "parentName": "任务标签",
          "orderNum": 0
        }
      ).then((resp) => {
        if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.tableData[this.currentIndex].taskLabel.push(this.taskLabelVal)
          this.taskLabelVal = '';
          this.getLabelOrCreate();
        } else {
          this.taskLabelVal = '';
          this.$message.error(resp.data.msg);
        }
      });
    },
  },
};
</script> 
<style scoped>
/* .el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
} */

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

.content {
  background: #fff;
  font-size: 18px;
}

.title {
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  background: #fff;
  color: #323233;
  padding:16px 0 10px 20px;
  margin-bottom: 0;
}


.base-content {
  display: flex;
  font-size: 15px;
  padding-bottom: 20px;
  padding-top: 6px;
  background:#fff;
}

.base-content .base-info {
  display: flex;
  align-items: center;
  padding: 0 40px;
}

.base-content .base-info .base-title {
  word-break: keep-all;
}

.button-area {
  display: flex;
  justify-content: space-between;
  padding-right: 15px;
  margin-top: 0;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.icon-dialog {
  display: flex;
  overflow: hidden;
}

.icon-dialog .icon-left {
  width: 130px;
  text-align: left;
  border-right: 1px solid #cccc;
}

.icon-left .item {
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  padding: 0 20px;
}

.icon-dialog .icon-right {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  height: auto;
  padding-left: 10px;
}

.icon-right .pic {
  width: 100px;
  height: 130px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.icon-right .pic .img {
  width: 100px;
  height: 100px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.06);
}

.icon-right .pic .img:hover {
  border: 1px solid #4fa1a4;
  border-radius: 4px;
}

.img-wrap {
  position: relative;
}

.img-wrap .border-img {
  position: absolute;
  width: 100px;
  height: 100px;
  left: 0;
  top: 0;
}

.img-wrap .name {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.file-img {
  width: 100%;
  height: 100%;
}

.icon-add {
  float: left;
  margin-left: 10px;
  width: 150px;
  height: 150px;
  border: 1px dotted #ccc;
  text-align: center;
  line-height: 150px;
}

.img-close {
  position: relative;
  float: left;
  width: 150px;
  height: 150px;
  margin-left: 20px;
}

.close {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
}
/deep/ .el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{
	height: 33px;
}
/deep/ .el-cascader__tags {
	display: inline-flex;
	flex-wrap: nowrap;
  overflow: hidden;
}

.btn-groups{
  background: #fff;
}
.btn-groups .btn-common{
  width: 120px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.btn-border-gray{
  background: #f0f0f0;
  color: #323233;
  border: 1px solid #dcdee0; 
}
/deep/ .table_header {
  background-color: #F0F0F0 !important;
  padding: 10px 0;
  color: #323233;
}
.header {
  background: #fff;
  margin: 4px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;

}
.header .back {
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}
.header .task-title{
    flex:1;
    font-weight:500px;
}
.header .task-title span{
  font-size:12px;
  color:#4fa1a4;
  margin-left:5px;
  cursor:pointer;
}
.tips{
  margin: 14px 10px 0 -10px;
  
}
</style>
<style >
.icon-dialog-wrap .el-dialog__body {
  padding: 0;
  padding-top: 10px;
}

#template-config .el-dialog {
  height: 80vh;
  overflow: auto;
}
#template-config .el-form-item__content{
  margin-left:15px !important;
}
#template-config .el-form-item{
  align-items:flex-start;
}
#template-config .calc-type .el-form-item__label{
  line-height:15px;
}

</style>

<style lang="less">
.cascader-popper {
  .el-cascader-menu {
    .el-cascader-menu__wrap {
      .el-cascader-menu__list {
        .is-disabled {
          display: none !important;
        }
      }
    }
  }
}
</style>